import React from 'react';
import { FaEye } from 'react-icons/fa';
import { trimCell } from '@/common/forms/TrimCell';
import { formatCurrency } from '@/common/utils/formatCurrency';
import { getBlockExplorerUrl } from '@/common/utils/block-explorer';
import ROUTES from '@/routes/routes-enums';
import { getStatusBadgeColor } from '../utils/get-status-badge-color';
import { getDepositStatus } from '../utils/get-deposits-status';
import { trimHash } from '@/common/utils/trim-hash';
import { ColumnDef } from '@tanstack/react-table';
import { DepositWithRelations } from '@repo/common-types';

export interface ColumnMeta {
  className?: string;
}

export const createColumns = (navigate: any): ColumnDef<DepositWithRelations>[] => [
  {
    header: 'Actions',
    cell: ({ row }) => (
      <button
        onClick={() => {
          navigate(ROUTES.DEPOSIT_DETAILS.replace(':id', row.original.id));
        }}
        className="btn btn-soft-primary btn-sm"
      >
        <FaEye />
      </button>
    ),
    enableSorting: false,
  },
  {
    header: 'Inbound Tx Id',
    cell: ({ row }) =>
      row.original.inboundTxId &&
      row.original.inboundTx.txId && (
        <a
          href={getBlockExplorerUrl(row.original.chain, row.original.inboundTx.txId)}
          target="_blank"
          rel="noopener noreferrer"
          className="text-decoration-underline"
        >
          {trimHash(row.original.inboundTx.txId)}
        </a>
      ),
    enableSorting: false,
  },
  {
    header: 'Outbound Tx Id',
    cell: ({ row }) =>
      row.original.outboundTxId &&
      row.original.outboundTx?.txId && (
        <a
          href={getBlockExplorerUrl(row.original.chain, row.original.outboundTx.txId)}
          target="_blank"
          rel="noopener noreferrer"
          className="text-decoration-underline"
        >
          {trimHash(row.original.outboundTx.txId)}
        </a>
      ),
    enableSorting: false,
  },
  {
    id: 'user.alias',
    accessorKey: 'user.alias',
    header: 'User',
    cell: ({ row }) => (
      <p
        onClick={() => navigate(`${ROUTES.USER}/${row.original.userId}`)}
        className="text-decoration-underline cursor-pointer"
      >
        {row.original.user.alias}
      </p>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'amount',
    header: 'Amount',
    cell: ({ row }) => <div className="text-end">{formatCurrency(row.original.amount, 9)}</div>,
    enableSorting: true,
    meta: {
      className: 'justify-content-end',
    },
  },
  {
    accessorKey: 'currency',
    header: 'Currency',
    enableSorting: true,
  },
  {
    accessorKey: 'chain',
    header: 'Chain',
    enableSorting: true,
  },
  {
    header: 'Deposit Status',
    cell: ({ row }) =>
      row.original.inboundTx && (
        <span
          className={`badge ${getStatusBadgeColor(getDepositStatus(row.original.inboundTx, row.original?.outboundTx))}`}
        >
          {getDepositStatus(row.original.inboundTx, row.original?.outboundTx)}
        </span>
      ),
    enableSorting: false,
  },
  {
    accessorKey: 'createdAt',
    header: 'Created At',
    cell: ({ row }) => new Date(row.original.createdAt).toLocaleString(),
    enableSorting: true,
  },
];
